import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as styles from './Spinner.scss';

var Spinner = /*#__PURE__*/function (_Component) {
  _inherits(Spinner, _Component);

  var _super = _createSuper(Spinner);

  function Spinner() {
    _classCallCheck(this, Spinner);

    return _super.apply(this, arguments);
  }

  _createClass(Spinner, [{
    key: "render",
    value: function render() {
      var style = Object.assign({
        position: 'absolute',
        left: '50%',
        top: 10,
        transform: 'translateX(-50%)'
      }, this.props.style);
      var sizeClass = this.props.size ? styles[this.props.size] : '';
      return /*#__PURE__*/React.createElement("div", {
        id: "Spinner",
        className: "".concat(styles.spinner, " ").concat(sizeClass),
        style: this.props.center ? style : this.props.style
      }, "Loading...");
    }
  }]);

  return Spinner;
}(Component);

_defineProperty(Spinner, "propTypes", {
  center: PropTypes.bool,
  size: PropTypes.oneOf(['small'])
});

_defineProperty(Spinner, "defaultProps", {
  center: false,
  style: {}
});

export default Spinner;